module.exports = __webpack_public_path__ + "media/site/images/key-features/screenshots/desktop-project-settlement@2x-51b2da60cd97a510d29043e58ea60667.png";